module.exports = __webpack_public_path__ + "static/img/Group1321316469.30521258.png";